import { StubPage } from '../StubPage'
export function Records() {
  return <StubPage title="Records (Coffees)" summary="A Coffee is one record in a Cup. Each Coffee has Beans — one per Cup Trait — holding the actual field values. Records are created through Interviewer steps, via the API, or directly in the Cup detail page. The Cup detail page lists all records and lets you view, edit, and delete them." />
}
